import React, { memo, Fragment, useMemo } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { WidgetProps } from '../types';
import { R } from '@core/utils/r';

export const WidgetIcons = memo((props: WidgetProps<any>) => {
  const widgetId = useMemo(() => R.random(1000, 909999), []);
  const { settings } = props;
  const hasError = useMemo(() => props.hasError, [props.hasError]);

  const info = useMemo(() => {
    const toolTip = (
      <UncontrolledTooltip placement="top" target={`stat-${widgetId}`}>
        {settings.description}
      </UncontrolledTooltip>
    );
    if (!R.isEmpty(settings.description)) {
      return (
        <Fragment>
          <i id={`stat-${widgetId}`} className="ml-2 fa fa-info-circle"></i>
          {toolTip}
        </Fragment>
      );
    }
    return null;
  }, [settings.description, widgetId]);

  const error = useMemo(() => {
    const toolTip = (
      <UncontrolledTooltip placement="top" target={`error-${widgetId}`}>
        This widget has an error. Please check the settings.
      </UncontrolledTooltip>
    );
    return (
      <Fragment>
        <i id={`error-${widgetId}`} className="ml-2 blinker fa fa-exclamation-triangle text-danger"></i>
        {toolTip}
      </Fragment>
    );
    return null;
  }, [widgetId]);

  const snapshot = useMemo(() => {
    const toolTip = (
      <UncontrolledTooltip placement="top" target={`stat-snapshot-${widgetId}`}>
        This is a snapshot metric. This means that it will always show the current number, regardless of what date range you select. This is used in
        certain situations such as Open Tickets (where the metric represents how many are currently open).
      </UncontrolledTooltip>
    );
    if (props.data && R.isEmpty(props.data.dateColumn)) {
      return (
        <Fragment>
          <i id={`stat-snapshot-${widgetId}`} className="ml-2 fa fa-camera"></i>
          {toolTip}
        </Fragment>
      );
    }
    return null;
  }, [props.data, widgetId]);

  return (
    <div className="widget-icons d-flex flex-row">
      {hasError && error}
      {info}
      {snapshot}
    </div>
  );
});
